import React from "react";
import get from "lodash/get";
import TextField from "components/FormFields/TextField";

const PortInNumberField = ({ data, portInNumberValidation, ...props }) => {
  const useContactNumberFormat = get(data, "useContactNumberFormat");
  const mask = data?.mask || get(props, "generic.contact_number.mask", {});
  const tooltip = get(props?.locale, data?.tooltip);
  return (
    <TextField
      inlineValidation={portInNumberValidation}
      {...(useContactNumberFormat && { mask })}
      {...props}
      {...data}
      tooltip={tooltip}
    />
  );
};

PortInNumberField.defaultProps = {
  label: ""
};

export default PortInNumberField;
